import { Col, Form, Row } from "react-bootstrap"
import { Door, Tenant } from "../data/models.interface"
import ForbiddenDoorsField from "./ForbiddenDoorsField"

interface ITenantForm {
	tenant: Tenant
	setTenant: (tenant: Tenant) => void
	doors?: Door[]
	touched: TenantTouched
	setTouched: (value: TenantTouched) => void
	validationErrors: TenantErrors
}
const TenantForm = ({ tenant, setTenant, doors, touched, setTouched, validationErrors }: ITenantForm) => {
	return (
		<>
			<Row className="mt-4">
				<Col xs={12} sm={3}>
					<Form.Group className="mb-3" controlId="name">
						<Form.Label>Name</Form.Label>
						<Form.Control type="text" value={tenant.Name || ""} readOnly />
					</Form.Group>
				</Col>
				<Col xs={12} sm={3}>
					<Form.Label>Units</Form.Label>
					{tenant.Leases?.map((lease) => (
						<Form.Control key={lease.Unit?.UnitID} type="text" value={lease.Unit?.Name} readOnly className="mb-1" />
					))}
				</Col>
				<Col xs={12} sm={6}>
					<ForbiddenDoorsField tenant={tenant} setTenant={setTenant} doors={doors} />
				</Col>
			</Row>
			<Row>
				<Col xs={12} sm={4} md={2}>
					<KeycardField fieldNumber={1} tenant={tenant} setTenant={setTenant} />
				</Col>
				<Col xs={12} sm={4} md={2}>
					<KeycardField fieldNumber={2} tenant={tenant} setTenant={setTenant} />
				</Col>
				<Col xs={12} sm={4} md={2}>
					<KeycardField fieldNumber={3} tenant={tenant} setTenant={setTenant} />
				</Col>
				<Col xs={12} sm={4} md={2}>
					<KeycardField fieldNumber={4} tenant={tenant} setTenant={setTenant} />
				</Col>
				<Col xs={12} sm={4} md={2}>
					<KeycardField fieldNumber={5} tenant={tenant} setTenant={setTenant} />
				</Col>
				<Col xs={12} sm={4} md={2}>
					<KeycardField fieldNumber={6} tenant={tenant} setTenant={setTenant} />
				</Col>
				<Col xs={12} sm={4} md={2}>
					<KeycardField fieldNumber={7} tenant={tenant} setTenant={setTenant} />
				</Col>
				<Col xs={12} sm={4} md={2}>
					<KeycardField fieldNumber={8} tenant={tenant} setTenant={setTenant} />
				</Col>
				<Col xs={12} sm={4} md={2}>
					<KeycardField fieldNumber={9} tenant={tenant} setTenant={setTenant} />
				</Col>
				<Col xs={12} sm={4} md={2}>
					<KeycardField fieldNumber={10} tenant={tenant} setTenant={setTenant} />
				</Col>
			</Row>
		</>
	)
}
export default TenantForm

const KeycardField = ({
	fieldNumber,
	tenant,
	setTenant,
}: {
	fieldNumber: number
	tenant: Tenant
	setTenant: (tenant: Tenant) => void
}) => {
	return (
		<Form.Group className="mb-3" controlId={"keycard" + fieldNumber}>
			<Form.Label>Keycard {fieldNumber}</Form.Label>
			<Form.Control
				type="text"
				value={tenant.UserDefinedValues.find((u) => u.Name === "Key Card " + fieldNumber)?.Value || ""}
				onChange={(e) => {
					let udf = tenant.UserDefinedValues.find((u) => u.Name === "Key Card " + fieldNumber)
					// make udf if it doesn't exist
					if (!udf) {
						// UserDefinedFieldID is ignored in the update
						udf = { Name: "Key Card " + fieldNumber, Value: e.target.value, UserDefinedFieldID: 0 }
						tenant.UserDefinedValues.push(udf)
					}
					//
					udf.Value = e.target.value
					setTenant({ ...tenant })
				}}
			/>
		</Form.Group>
	)
}

export interface TenantTouched {
	keycard1?: boolean
	keycard2?: boolean
	keycard3?: boolean
	keycard4?: boolean
	keycard5?: boolean
	keycard6?: boolean
	keycard7?: boolean
	keycard8?: boolean
	keycard9?: boolean
	keycard10?: boolean
}
export interface TenantErrors {
	keycard1?: string
	keycard2?: string
	keycard3?: string
	keycard4?: string
	keycard5?: string
	keycard6?: string
	keycard7?: string
	keycard8?: string
	keycard9?: string
	keycard10?: string
}
